export const TaxBracket = [
  '0_15',
  '15_30',
  '30_45',
  '45',

  // Prepop
  '0%-15%',
  '15%-30%',
  '30%-45%',
  '45%+'
];
